import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ToastInterface } from '../../entities/Toast/Toast';

export type ToastState = {
    toastList: ToastInterface[];
};

const initialState: ToastState = {
    toastList: [],
};

const toastSlice = createSlice({
    name: 'toastSlice',
    initialState,
    reducers: {
        setToastList(state, action: PayloadAction<ToastInterface[]>): ToastState {
            return {
                ...state,
                toastList: action.payload,
            };
        },
    },
});

export const {
    setToastList,
} = toastSlice.actions;

export default toastSlice;
